module.exports = __webpack_public_path__ + "img/status-tick.f590b1a1.svg";